export const cardioHeroData = {
    title: "Cardiovascular Diseases",
    subtitle: "Heart disease, hypertension, and cholesterol management",
    stats: [
        { number: "30+ Medications", label: "Medications" },
        { number: "Save up to 90%", label: "Our Price" },
        { number: "WHO-GMP Certified", label: "Quality Assurance" }
    ]
};

export const cardioProducts = [
    {
        id: "atorvastatin-40mg",
        name: "Atorvastatin 40mg",
        genericName: "Lipitor Equivalent",
        indication: "High Cholesterol",
        originalPrice: "$400",
        price: "$55",
        savings: "86%",
        description: "A statin medication used to prevent cardiovascular disease in those at high risk and treat abnormal lipid levels.",
        dosage: "Commonly taken once daily at the same time each day.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Pfizer / Licensed Generic Manufacturers",
        storage: "Store at room temperature 20-25°C.",
        sideEffects: "Joint pain, diarrhea, and common cold symptoms.",
        category: "Cholesterol"
    },
    {
        id: "clopidogrel-75mg",
        name: "Clopidogrel 75mg",
        genericName: "Plavix Equivalent",
        indication: "Blood Thinner",
        originalPrice: "$300",
        price: "$25",
        savings: "92%",
        description: "Used to reduce the risk of heart disease and stroke in those at high risk.",
        dosage: "75 mg once daily with or without food.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Bristol-Myers Squibb / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Bleeding, headache, and dizziness.",
        category: "Blood Thinners"
    },
    {
        id: "enalapril-20mg",
        name: "Enalapril 20mg",
        genericName: "Vasotec Equivalent",
        indication: "Hypertension / Heart Failure",
        originalPrice: "$400",
        price: "$19",
        savings: "95%",
        description: "An ACE inhibitor used to treat high blood pressure, diabetic kidney disease, and heart failure.",
        dosage: "Start with 5 mg daily, maintenance 10-40 mg daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Cough, dizziness, and low blood pressure.",
        category: "Blood Pressure"
    },
    {
        id: "metoprolol-100mg",
        name: "Metoprolol 100mg",
        genericName: "Lopressor / Toprol-XL",
        indication: "Hypertension / Angina",
        originalPrice: "$300",
        price: "$22",
        savings: "93%",
        description: "A selective β1 receptor blocker medication used to treat high blood pressure, chest pain (angina), and fast heart rate.",
        dosage: "Usually 50-100 mg daily in single or divided doses.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Novartis / Licensed Generic Manufacturers",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Tiredness, dizziness, and slow heartbeat.",
        category: "Blood Pressure"
    },
    {
        id: "amlodipine-10mg",
        name: "Amlodipine 10mg",
        genericName: "Norvasc Equivalent",
        indication: "Hypertension / Angina",
        originalPrice: "$280",
        price: "$15",
        savings: "95%",
        description: "A calcium channel blocker used to treat high blood pressure and chest pain (angina).",
        dosage: "5-10 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Pfizer / Licensed Generic Manufacturers",
        storage: "Store at room temperature away from light.",
        sideEffects: "Swelling of legs/ankles, fatigue, and palpitations.",
        category: "Blood Pressure"
    },
    {
        id: "losartan-100mg",
        name: "Losartan 100mg",
        genericName: "Cozaar Equivalent",
        indication: "Hypertension",
        originalPrice: "$300",
        price: "$24",
        savings: "92%",
        description: "An angiotensin II receptor antagonist used to treat high blood pressure.",
        dosage: "50-100 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature in a tight container.",
        sideEffects: "Dizziness, upper respiratory infection, and back pain.",
        category: "Blood Pressure"
    },
    {
        id: "lisinopril-20mg",
        name: "Lisinopril 20mg",
        genericName: "Prinivil / Zestril",
        indication: "Hypertension / Heart Failure",
        originalPrice: "$400",
        price: "$17",
        savings: "96%",
        description: "An ACE inhibitor used to treat high blood pressure, heart failure, and after heart attacks.",
        dosage: "10-40 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Dry cough, dizziness, and headache.",
        category: "Blood Pressure"
    },
    {
        id: "rosuvastatin-20mg",
        name: "Rosuvastatin 20mg",
        genericName: "Crestor Equivalent",
        indication: "High Cholesterol",
        originalPrice: "$500",
        price: "$48",
        savings: "90%",
        description: "A statin medication used with diet to reduce 'bad' cholesterol and raise 'good' cholesterol.",
        dosage: "5-40 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "AstraZeneca / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Muscle pain, headache, and weakness.",
        category: "Cholesterol"
    },
    {
        id: "warfarin-5mg",
        name: "Warfarin 5mg",
        genericName: "Coumadin Equivalent",
        indication: "Blood Clot Prevention",
        originalPrice: "$150",
        price: "$12",
        savings: "92%",
        description: "An anticoagulant (blood thinner) used to prevent and treat blood clots.",
        dosage: "Dose based on INR blood test results.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Bleeding and bruising.",
        category: "Blood Thinners"
    },
    {
        id: "digoxin-0.25mg",
        name: "Digoxin 0.25mg",
        genericName: "Lanoxin Equivalent",
        indication: "Heart Failure / Arrhythmia",
        originalPrice: "$120",
        price: "$10",
        savings: "92%",
        description: "Derived from the foxglove plant, it helps the heart beat stronger and with a more regular rhythm.",
        dosage: "Usually taken once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Nausea, vomiting, and loss of appetite.",
        category: "Heart Rhythm"
    },
    {
        id: "rivaroxaban-20mg",
        name: "Rivaroxaban 20mg",
        genericName: "Xarelto Equivalent",
        indication: "Blood Clot Prevention",
        originalPrice: "$600",
        price: "$42",
        savings: "93%",
        description: "An oral anticoagulant used to prevent and treat blood clots in veins and arteries.",
        dosage: "20 mg once daily with food.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Bayer / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Bleeding and bruising.",
        category: "Blood Thinners"
    },
    {
        id: "apixaban-5mg",
        name: "Apixaban 5mg",
        genericName: "Eliquis Equivalent",
        indication: "Stroke/Clot Prevention",
        originalPrice: "$600",
        price: "$45",
        savings: "92%",
        description: "Used to prevent serious blood clots from forming due to a certain irregular heartbeat (atrial fibrillation).",
        dosage: "5 mg twice daily for most patients.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Bristol-Myers Squibb / generic",
        storage: "Store at room temperature.",
        sideEffects: "Bleeding, nausea, and rash.",
        category: "Blood Thinners"
    },
    {
        id: "dabigatran-150mg",
        name: "Dabigatran 150mg",
        genericName: "Pradaxa Equivalent",
        indication: "Afib / Clot Prevention",
        originalPrice: "$550",
        price: "$40",
        savings: "93%",
        description: "A direct thrombin inhibitor used to reduce the risk of stroke and system embolism.",
        dosage: "150 mg twice daily.",
        packaging: "Pack of 60 Capsules",
        manufacturer: "Boehringer Ingelheim / generic",
        storage: "Store in the original package to protect from moisture.",
        sideEffects: "Stomach pain, nausea, and heartburn.",
        category: "Blood Thinners"
    },
    {
        id: "valsartan-160mg",
        name: "Valsartan 160mg",
        genericName: "Diovan Equivalent",
        indication: "Hypertension / Heart Failure",
        originalPrice: "$300",
        price: "$20",
        savings: "93%",
        description: "An angiotensin receptor blocker (ARB) that keeps blood vessels from narrowing.",
        dosage: "80-320 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Novartis / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Dizziness, tiredness, and high potassium levels.",
        category: "Blood Pressure"
    },
    {
        id: "carvedilol-25mg",
        name: "Carvedilol 25mg",
        genericName: "Coreg Equivalent",
        indication: "Heart Failure / Hypertension",
        originalPrice: "$200",
        price: "$12",
        savings: "94%",
        description: "A beta-blocker that affects the heart and circulation.",
        dosage: "Usually taken twice daily with food.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Dizziness, tiredness, and low blood pressure.",
        category: "Heart Failure"
    },
    {
        id: "bisoprolol-10mg",
        name: "Bisoprolol 10mg",
        genericName: "Zebeta Equivalent",
        indication: "Hypertension / Heart Failure",
        originalPrice: "$220",
        price: "$14",
        savings: "94%",
        description: "A beta-blocker used for several cardiovascular conditions.",
        dosage: "Start with 5 mg, maintenance 10-20 mg daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Tiredness, slow heart rate, and cold extremities.",
        category: "Blood Pressure"
    },
    {
        id: "diltiazem-180mg",
        name: "Diltiazem 180mg",
        genericName: "Cardizem Equivalent",
        indication: "Hypertension / Angina",
        originalPrice: "$450",
        price: "$28",
        savings: "94%",
        description: "A calcium channel blocker used to treat high blood pressure and chest pain.",
        dosage: "120-360 mg daily in divided doses (or XR once daily).",
        packaging: "Bottle of 30 Capsules",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, swelling, and dizziness.",
        category: "Blood Pressure"
    },
    {
        id: "verapamil-240mg",
        name: "Verapamil 240mg",
        genericName: "Calan / Isoptin",
        indication: "Hypertension / Angina / Afib",
        originalPrice: "$350",
        price: "$21",
        savings: "94%",
        description: "A calcium channel blocker used to treat several heart conditions.",
        dosage: "80-120 mg three times daily (or XR once daily).",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store protected from light and moisture.",
        sideEffects: "Constipation, dizziness, and nausea.",
        category: "Blood Pressure"
    },
    {
        id: "ezetimibe-10mg",
        name: "Ezetimibe 10mg",
        genericName: "Zetia Equivalent",
        indication: "High Cholesterol",
        originalPrice: "$450",
        price: "$30",
        savings: "93%",
        description: "Used to lower cholesterol by reducing its absorption in the small intestine.",
        dosage: "10 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Diarrhea, joint pain, and fatigue.",
        category: "Cholesterol"
    },
    {
        id: "fenofibrate-160mg",
        name: "Fenofibrate 160mg",
        genericName: "Tricor Equivalent",
        indication: "High Triglycerides",
        originalPrice: "$300",
        price: "$24",
        savings: "92%",
        description: "Used to lower triglycerides and cholesterol in blood.",
        dosage: "160 mg once daily with food.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store in original container away from heat.",
        sideEffects: "Stomach pain, back pain, and headache.",
        category: "Cholesterol"
    },
    {
        id: "nifedipine-60mg",
        name: "Nifedipine 60mg",
        genericName: "Adalat CC / Procardia XL",
        indication: "Hypertension / Angina",
        originalPrice: "$400",
        price: "$22",
        savings: "94%",
        description: "A calcium channel blocker used to manage angina and hypertension.",
        dosage: "30-90 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Bayer / Licensed Generic Manufacturers",
        storage: "Store at room temperature protected from light.",
        sideEffects: "Dizziness, swelling, and headache.",
        category: "Blood Pressure"
    },
    {
        id: "hydralazine-50mg",
        name: "Hydralazine 50mg",
        genericName: "Apresoline Equivalent",
        indication: "Hypertension",
        originalPrice: "$250",
        price: "$16",
        savings: "94%",
        description: "A vasodilator used to treat high blood pressure.",
        dosage: "10-50 mg four times daily.",
        packaging: "Bottle of 100 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, palpitations, and nausea.",
        category: "Blood Pressure"
    },
    {
        id: "isosorbide-mononitrate-60mg",
        name: "Isosorbide Mononitrate 60mg",
        genericName: "Imdur Equivalent",
        indication: "Angina Prevention",
        originalPrice: "$400",
        price: "$18",
        savings: "95%",
        description: "Used to prevent chest pain (angina) caused by heart disease.",
        dosage: "30-120 mg once daily in the morning.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Headache, dizziness, and low blood pressure.",
        category: "Angina"
    },
    {
        id: "nitroglycerin-patch",
        name: "Nitroglycerin Patch",
        genericName: "Nitro-Dur Equivalent",
        indication: "Angina Prevention",
        originalPrice: "$300",
        price: "$21",
        savings: "93%",
        description: "A nitrate used to prevent angina attacks.",
        dosage: "Apply one patch daily for 12-14 hours.",
        packaging: "Box of 30 Patches",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature. Do not refrigerate.",
        sideEffects: "Headache, dizziness, and skin irritation.",
        category: "Angina"
    },
    {
        id: "prasugrel-10mg",
        name: "Prasugrel 10mg",
        genericName: "Effient Equivalent",
        indication: "Blood Thinner",
        originalPrice: "$400",
        price: "$31",
        savings: "92%",
        description: "Used to prevent blood clots in people with acute coronary syndrome undergoing a procedure after a recent heart attack.",
        dosage: "10 mg once daily.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Eli Lilly / generic",
        storage: "Store in original container to protect from moisture.",
        sideEffects: "Bleeding and easy bruising.",
        category: "Blood Thinners"
    },
    {
        id: "ticagrelor-90mg",
        name: "Ticagrelor 90mg",
        genericName: "Brilinta Equivalent",
        indication: "Heart Attack / Stroke Prevention",
        originalPrice: "$500",
        price: "$35",
        savings: "93%",
        description: "An adenosine diphosphate (ADP) receptor antagonist used to prevent cardiovascular events.",
        dosage: "90 mg twice daily.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "AstraZeneca / generic",
        storage: "Store at room temperature.",
        sideEffects: "Shortness of breath and bleeding.",
        category: "Blood Thinners"
    },
    {
        id: "sacubitril-valsartan",
        name: "Sacubitril / Valsartan",
        genericName: "Entresto Equivalent",
        indication: "Heart Failure",
        originalPrice: "$600",
        price: "$50",
        savings: "92%",
        description: "A combination medication used in people with certain types of heart failure.",
        dosage: "Usually taken twice daily.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Novartis / generic",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Low blood pressure, high potassium, and kidney issues.",
        category: "Heart Failure"
    },
    {
        id: "ivabradine-7.5mg",
        name: "Ivabradine 7.5mg",
        genericName: "Corlanor Equivalent",
        indication: "Heart Failure",
        originalPrice: "$450",
        price: "$22",
        savings: "95%",
        description: "A heart-rate lowering medication used in certain chronic heart failure patients.",
        dosage: "5-7.5 mg twice daily with food.",
        packaging: "Pack of 56 Tablets",
        manufacturer: "Amgen / generic",
        storage: "Store at room temperature protected from light.",
        sideEffects: "Slow heart rate and visual brightness.",
        category: "Heart Failure"
    },
    {
        id: "ranolazine-1000mg",
        name: "Ranolazine 1000mg",
        genericName: "Ranexa Equivalent",
        indication: "Chronic Angina",
        originalPrice: "$550",
        price: "$38",
        savings: "93%",
        description: "Used to treat chronic chest pain (angina).",
        dosage: "500-1000 mg twice daily.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Gilead / generic",
        storage: "Store at room temperature.",
        sideEffects: "Dizziness, headache, and constipation.",
        category: "Angina"
    },
    {
        id: "spironolactone-50mg",
        name: "Spironolactone 50mg",
        genericName: "Aldactone Equivalent",
        indication: "Heart Failure / Hypertension",
        originalPrice: "$220",
        price: "$15",
        savings: "93%",
        description: "A potassium-sparing diuretic (water pill) that prevents your body from absorbing too much salt.",
        dosage: "25-200 mg daily in single or divided doses.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "High potassium and breast swelling in men.",
        category: "Diuretics"
    }
];

export const cardioCategories = [
    "All Categories",
    "Blood Pressure",
    "Cholesterol",
    "Blood Thinners",
    "Heart Failure",
    "Heart Rhythm",
    "Angina",
    "Diuretics"
];

export const cardioTrustBadges = [
    { icon: "ShieldCheck", text: "100% Quality Assurance" },
    { icon: "Plane", text: "Safe Global Packaging" },
    { icon: "Award", text: "Board Certified Pharmacists" }
];

export const cardioFAQs = [
    {
        question: "Can I switch from my branded heart medication to a generic one?",
        answer: "Yes, generics are required by regulatory authorities to have the same active ingredient, strength, and effectiveness as the branded drugs. Consult your cardiologist before switching to ensure the transition is monitored properly."
    },
    {
        question: "How should I store my cardiovascular medications?",
        answer: "Most should be stored at room temperature, away from direct sunlight and moisture. However, some medications like Pradaxa (Dabigatran) must be kept specifically in their original packaging. Always check the storage instructions on your medication's label."
    },
    {
        question: "Do you ship refrigerated heart medications?",
        answer: "Currently, most of the cardiovascular medications we offer are stable at room temperature. If a medication requires temperature control, we use specialized medical-grade cold chain packaging to ensure safety during transit."
    }
];

export const cardioTestimonials = [
    {
        name: "Robert M.",
        country: "Australia",
        savings: "$4,800 annually",
        condition: "Chronic Hypertension",
        medication: "Telmisartan / Amlodipine",
        testimonial: "Managing blood pressure for 15 years gets expensive. MediSeller has become my go-to for affordable, consistent supply. My doctor says my readings are better than ever.",
        rating: 5
    },
    {
        name: "Linda K.",
        country: "Canada",
        savings: "$700/month",
        condition: "Post-Afib Management",
        medication: "Xarelto Equivalent",
        testimonial: "I was paying a fortune locally for my blood thinners. Switching to the generic through MediSeller saved me thousands without any change in my lab results. Highly recommended!",
        rating: 5
    }
];

export const cardioSectionContent = {
    midPageCTA: {
        title: "Looking for a Specific Cardiac Therapy?",
        description: "We source a wide range of cardiovascular medications from the world's most trusted manufacturers. If you don't see your specific prescription here, our pharmacists can help you find it.",
        whatsappText: "Inquire Now",
        requestText: "Search Your Medicine"
    },
    testimonials: {
        title: "Heart Care Success Stories",
        description: "See how thousands of patients have managed their cardiovascular health while saving significantly on their medication costs."
    },
    faqs: {
        title: "Cardiovascular Care FAQ",
        description: "Expert answers to common questions about heart medications, quality, and shipping."
    },
    finalCTA: {
        title: "Take Control of Your Heart Health",
        description: "Access affordable, high-quality cardiovascular treatments with secure global shipping and dedicated patient support.",
        whatsappText: "Chat with Pharmacist",
        requestText: "Upload Prescription"
    }
};
